import { useEffect, useState } from 'react';

/// O instante atual como estado, relido de tempos em tempos. Ler o relógio durante a renderização
/// daria uma resposta diferente a cada render; aqui ele muda só quando o intervalo passa, e a tela
/// que depende de "já começou?" se atualiza sozinha.
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
